//
// login.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/*jshint devel: true, jquery: true */

const CRL8OPS = window.CRL8OPS || {};
CRL8OPS.pages = CRL8OPS.pages || {};

function globalGoogleSigninOnload() {
    CRL8OPS.pages.login.init();
}

CRL8OPS.pages.login = (function() {

    // global variable for accessing gapi after init
    let googleAuth2;

    const ORIGINAL_REQUEST_URL = 'original_request_url';

    // function vars
    let initOnLoad, initCompleteSuccessLogin, initCompleteFailed, attemptSignin, signInCallback, displayError;

    initOnLoad = function() {
        let clientid;

        // Initialize the google API
        gapi.load('auth2', function () {
            clientid = $('#login_box').attr("clientid");
            googleAuth2 = gapi.auth2.init({
                client_id: clientid,
                scope: 'profile'
            });
            googleAuth2.then(initCompleteSuccessLogin, initCompleteFailed);
        });
    };

    initCompleteSuccessLogin = function() {
        $('#login_box').append('<a href="#" onclick="CRL8OPS.pages.login.signin()"><img src="/img/Blue_signin_Medium_pressed_32dp_v3.png"/></a>');
    };

    initCompleteFailed = function(reason) {
        displayError("Login initialization failed. Please try again later");
    };

    attemptSignin = function() {
        // Request a one-time code from google
        googleAuth2.grantOfflineAccess({'redirect_uri': 'postmessage'}).then(signInCallback);
    };

    signInCallback = function (authResult) {

        const stateid = $('#login_box').attr("stateid");
        const BASE_URL = "/login/login-code";

        // Google has returned with a one-time code. Post it to the Curalate server now, which will
        // then communicate with Google to get id_token, access_token, and refresh_tokens
        if (authResult.code) {

            $.post(BASE_URL,
                {
                    "code": authResult.code,
                    "stateid": stateid
                },
                function (data, status) {

                    if (status === "success") {
                        $('#login_box').empty();
                        const originalRequestUrl = $.cookie(ORIGINAL_REQUEST_URL);
                        if (originalRequestUrl) {
                            $.removeCookie(ORIGINAL_REQUEST_URL);
                            window.location.replace(originalRequestUrl);
                        } else {
                            window.location.replace("/v1");
                        }

                    } else {
                        displayError("Login failed with " + status + ". Please try again.");
                    }
                },
                'json').fail(function (jqXHR) {
                    if (jqXHR.status === 401) {
                        displayError("Authorization to this resource has been denied.");
                    } else {
                        displayError("The login may have failed due to a communication issue. Please try again.");
                    }
                });

        } else {
            displayError("Login cannot proceed to the next step. Please try again.");
        }
    };

    displayError = function(msg) {
        window.alert(msg);
        window.location.replace("/v1");
    };

    return {
        init: function() {
            initOnLoad();
        },

        signin: function() {
            attemptSignin();
        }
    };
})();
